import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import { useDispatch } from "react-redux";
import { addSurroundingIndustry } from "../../Redux/Actions/surroundingIndutriesActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const AddSurroundingIndustries = () => {
  const [industryData, setIndustryData] = useState({
    name: "",
    image: "",
  });

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const result = await dispatch(addSurroundingIndustry(industryData));
      if (result.statusCode === 200) {
      setIndustryData({ name: "", image: "" });
    }
    } catch (error) {
      console.log("",error);
    }
  };

  return (
    <MainLayout>
      <div className="bg-white border-24 grid-span-5 padding-20">
        <div className="flex-container flex-justify-between align-center">
          <h1>Add Surrounding Industry</h1>
          <Link to={"/surrounding-industries"}>
            <button className="button-class">View Surrounding Industries List</button>
          </Link>
        </div>
        <form>
          <div className="flex-container gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                placeholder="Enter Name"
                label="Brand Name"
                required={true}
                name="name"
                value={industryData.name}
                onChange={(event) =>
                  setIndustryData((prevData) => ({
                    ...prevData,
                    name: event.target.value,
                  }))
                }
              ></TextInput>
            </div>

            <div style={{ width: "50%" }}>
              <span className="span-class">
                Add Image<span style={{ color: "red" }}>*</span>
              </span>
              <input
                className="input-class"
                id="image"
                style={{ display: "none" }}
                onChange={async (event) => {
                  const uploadedImage = event.target.files[0];
                  if (!uploadedImage) return;
                  const responseUrl = await AddImage(uploadedImage);
                  if (responseUrl) {
                    setIndustryData((prevData) => ({
                      ...prevData,
                      image: responseUrl,
                    }));
                  }
                }}
                type="file"
              />
              <label className="label-class-image" for="image">
                Click to Upload Image
              </label>

              <ImageShowerModalGlobal
                file={industryData.image}
                keyField="image"
                setState={setIndustryData}
                state={industryData}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-end margin-h-10">
            <div>
              <Link to="/surrounding-industries">
                <button className="button-class-white">Cancel</button>
              </Link>
              <button onClick={handleSubmit} className="button-class">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddSurroundingIndustries;
